export const tableColumnsData = [
  { title: "Name" },
  { title: "Username" },
  { title: "Email" },
  { title: "Phone" },
  { title: "Website" },
  { title: "Address" },
];
